export default __webpack_public_path__ + "static/media/07b246cb08f0056bf96a8effcd0e4dfa.93dcdcf0.svg";